<template>
    <div class="evaling" id="evaling">
       <app-header v-if="header_show"></app-header>
       <!-- 我的测评 -->
       <div class="content">
         <div class="question">
           <div class="time">
             <span>剩余时长:00:59:00</span>
             <img src="../../assets/images/achieve_time.png" alt="">
           </div>
           <div class="title">【单选题/10分】</div>
           <div class="intro">1.测试题目测试题目测试题目测试题目测试题目测试题目测试题目题目测试题目测试题目</div>
         </div>

         <div class="answer">
           <div class="list">
             <input id="answer1" type="checkbox">
             <label for="answer1">
                 <slot>A:答案A</slot>
             </label>
           </div>
           <div class="list">
             <input id="answer2" type="checkbox">
             <label for="answer2">
                 <slot>B:答案B</slot>
             </label>
           </div>
           <div class="list">
             <input id="answer3" type="checkbox">
             <label for="answer3">
                 <slot>C:答案C</slot>
             </label>
           </div>
         </div>

         <div class="bottom">
           <p class="step">第2题 共10题</p>
           <div class="btns">
             <div class="prev">上一题</div>
             <div class="submit">提交试卷</div>
             <div class="next">下一题</div>
           </div>
         </div>
       </div>
    </div>
</template>

<script>
  import Header from '@/components/Header'
  export default {
    name: 'evaling',
    components: {
      'app-header':Header,
    },
    data () {
      return {
        header_show:true,
      }
    },
    methods:{

    }
  }
</script>
<style scoped>
.content{
  width: 15rem;
  margin: 0 auto;
  padding-bottom: 0.84rem;
}
.question{
  width: 100%;
}
.question .time{
  height: 0.41rem;
  line-height: 0.41rem;
  margin-top: 1rem;
}
.question .time img{
  width: 0.37rem;
  height: 0.41rem;
  float: right;
}
.question .time span{
  font-size: 0.25rem;
  color: #404040;
  float: right;
  margin: 0 0.58rem 0 0.11rem;
}
.question .title{
  font-size: 0.33rem;
  color: #404040;
  width: 11.6rem;
  margin: 0 auto;
}
.question .intro{
  font-size: 0.33rem;
  color: #404040;
  width: 11.6rem;
  margin: 0.2rem auto;
  line-height: 0.6rem;
}
.answer{
  width: 11.6rem;
  margin: 0.5rem auto;
}
.answer .list{
  width: 100%;
  font-size: 0.33rem;
  color: #404040;
  margin-top: 0.49rem;
  cursor: pointer;
}
.answer .list input{
  width: 0.2rem;
  height: 0.2rem;
}

.bottom{
  width: 11.6rem;
  margin: 0 auto;
}
.bottom .step{
  font-size: 0.25rem;
  color: #404040;
  text-align: center;
}
.bottom .btns{
  width: 100%;
  height: 0.6rem;
  margin-top: 0.36rem;
}
.bottom .btns div{
  font-size: 0.25rem;
  width: 1.38rem;
  height: 0.59rem;
  float: left;
  text-align: center;
  line-height: 0.59rem;
  margin: 0 1.2rem;
  border: 1px solid #2b73cc;
  color: #2b73cc;
  cursor: pointer;
}
.bottom .btns .prev{
  background-color: #fff;
}
.bottom .btns .submit{
  color: #fff;
  background-color: #2b73cc;
}
.bottom .btns .next{
  background-color: #fff;
}



</style>



// WEBPACK FOOTER //
// src/components/index/Evaling.vue